module.exports = __webpack_public_path__ + "img/8f06b04.png";